/**
 * This file is responsible for handling the service calls for the account
 */
import store from "../store";
import { callAPI, GATEWAY_PROXY, METHODS } from "utils/apiUtils";
import { beeTemplate } from "../scenes/campaigns/scenes/campaignFlow/data/baseTemplates";
import "regenerator-runtime/runtime";
import {
	listAutomationsService as listAutomationsServiceV1,
	deleteAutomationService as deleteAutomationServiceV1,
	patchAutomationService as patchAutomationServiceV1,
} from "assets/js/services/automationServiceV1";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";

function listAutomationsService(
	options,
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations`,
			method: METHODS.get,
			query: { ...options },
		},
		successCallback,
		failureCallback
	);
}

function deactivateAutomationService(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${id}/deactivate`,
			method: METHODS.post,
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_DEACTIVATED, data);
			successCallback(data);
		},
		failureCallback
	);
}

function activateAutomationService(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${id}/activate`,
			method: METHODS.post,
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_ACTIVATED, data);
			successCallback(data);
		},
		failureCallback
	);
}
function getAutomationService(
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, ...rest } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${id}`,
			method: METHODS.get,

		},
		successCallback,
		failureCallback
	);
}

function sendTestActionService(
	options = { automationId: "", stepId: "", email: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { automationId, stepId, email } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${automationId}/steps/${stepId}/test`,
			method: METHODS.post,
			body: { email: email },

		},
		successCallback,
		failureCallback
	);
}

function createEmailService(
	options = { id: "", json: null, html: null },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { id, json, html } = options;
	const queryParams = {};

	if (json) {
		let headers = {
			"Content-Type": "application/json",
			"Access-Control-Allow-Origin": "*",
		};
		callAPI(
			{
				url: `${GATEWAY_PROXY}/content/${id}/json`,
				method: METHODS.put,
				body: json,
				query: {
					...queryParams,
					generateHtml: true,
				},
				headers: headers,
			},
			successCallback,
			failureCallback
		);
	} else if (html) {
		callAPI(
			{
				url: `${GATEWAY_PROXY}/content/${id}/html`,
				method: METHODS.put,
				body: html,
				headers: { "content-type": "text/html" },

			},
			successCallback,
			failureCallback
		);
	}
}

function getEmailContentService(
	options = { contentId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { contentId } = options;
	if (contentId == "scratchBee1") {
		successCallback({
			id: "scratchBee1",
			thumbnail: "/assets/images/campaigns/beeTemplate.png",
		});
	} else {
		callAPI(
			{
				url: `${GATEWAY_PROXY}/content/${contentId}`,
				method: METHODS.get,

			},
			successCallback,
			failureCallback
		);
	}
}

function getEmailContentServiceJson(
	options = { contentId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { contentId } = options;
	if (contentId == "scratchBee1") {
		successCallback(beeTemplate());
	} else {
		callAPI(
			{
				url: `${GATEWAY_PROXY}/content/${contentId}/json`,
				method: METHODS.get,

			},
			successCallback,
			failureCallback
		);
	}
}

function getEmailContentServiceHTML(
	options = { contentId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { contentId } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/content/${contentId}/html`,
			method: METHODS.get,

		},
		successCallback,
		failureCallback
	);
}

function createEmailContentService(
	options = { subject: "", html: null, json: null, senderId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) {
	const { subject, html, json, senderId } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/content`,
			method: METHODS.post,
			body: {
				subject: subject,
				senderId: senderId,
			},

		},
		(data) => {
			createEmailService(
				{
					id: data.id,
					json: json,
					html: html,
				},
				() => successCallback(data)
			);
		},
		failureCallback
	);
}

const createAutomationService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations`,
			method: METHODS.post,
			body: options,
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_CREATED, data.data);
			successCallback(data);
		},
		failureCallback
	);
};

const updateAutomationService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	//  update the automation object with the editor version
	//	options.automation.editor_version =
	//options.automation.editorVersion;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${options.id}`,
			method: METHODS.put,
			body: options.automation,

		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_UPDATED, data.data);
			successCallback(data);
		},
		failureCallback
	);
};

const terminateExecutionService = (
	options = { automationId: "", executionId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, executionId, ...restOptions } = options;
	callAPI(
		{
			url: `${GATEWAY_PROXY}/automations/${automationId}/executions/${executionId}/terminate`,
			method: METHODS.post,

			body: restOptions,
		},
		successCallback,
		failureCallback
	);
};

const terminateAutomationService = (
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/terminate`,
			method: METHODS.post,
			body: restOptions,

		},
		successCallback,
		failureCallback
	);
};

const pauseAutomationService = (
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/pause`,
			method: METHODS.post,
			body: restOptions,

		},
		successCallback,
		failureCallback
	);
};

const unpauseAutomationService = (
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/resume`,
			method: METHODS.post,
			body: restOptions,

		},
		successCallback,
		failureCallback
	);
};

const publishAutomationService = (
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/commit`,
			method: METHODS.post,
			body: restOptions,

			skipRetry: true,
		},
		successCallback,
		failureCallback
	);
};

const listAutomationExecutionsService = (
	options = { automationId: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, ...restOptions } = options;


	const params = {};
	if (options.perPage) params.pageSize = options.perPage;
	if (options.nextPageToken) params.pageToken = options.nextPageToken;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/executions`,
			method: METHODS.get,
			query: params,
		},
		successCallback,
		failureCallback
	);
};

const deleteAutomationService = (
	options = { id: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { id, ...restOptions } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${id}`,
			method: METHODS.delete,
			body: restOptions,

		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.AUTOMATION_DELETED, data.data);
			successCallback(data);
		},
		failureCallback
	);
};

const renameAutomationService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { automationId, newName } = options;
	// we need to get the automation first
	getAutomationService({ id: automationId }, (data) => {
		data.data.name = newName;
		updateAutomationService({ automation: data.data, id: automationId }, () => {
			successCallback(data), failureCallback;
		});
	});
};

const getStepStatsService = (
	options = { stepId: "", automationId: "", start_time: null, end_time: null },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const { stepId, automationId, ...restOptions } = options;
	if (restOptions.startTime) {
		restOptions.start_time = restOptions.startTime;
		delete restOptions.startTime;
	}
	if (restOptions.endTime) {
		restOptions.end_time = restOptions.endTime;
		delete restOptions.endTime;
	}

	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/steps/${stepId}/stats`,
			method: METHODS.get,
			query: { ...restOptions },
		},
		successCallback,
		failureCallback
	);
};

const copyEmailContentService = (
	options = { contentId: "", senderId: "", subject: "" },
	successCallback = () => { },
	failureCallback = () => { }
) => {
	// we need to get the automation first
	const { contentId, senderId, subject, ...restOptions } = options;
	getEmailContentServiceJson({ contentId: contentId }, (jsonData) => {
		const json = jsonData;

		const options = { subject, generateHtml: true, json: json, senderId };
		createEmailContentService(
			options,
			(data) => {
				successCallback(data);
			},
			() => {
				failureCallback();
			}
		);
	}, () => {
		failureCallback();
	});
};

const listAllAutomationsService = async (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	const promises = [];
	promises.push(
		new Promise((resolve, reject) => {
			listAutomationsService(
				options,
				(data) => {
					resolve({
						...data,
						data: data.data.filter(
							(automation) => automation.editor_version != "manual"
						),
					});
				},
				reject
			);
		})
	);

	promises.push(
		new Promise((resolve, reject) => {
			listAutomationsServiceV1(
				{ ...options, perPage: 1000 },
				(data) => {
					data.data.forEach((automation) => (automation.v1 = true));
					resolve(data);
				},
				reject
			);
		})
	);

	await Promise.all(promises)
		.then((data) => {
			let result = [];
			data.forEach((data) => {
				result.push(...data.data);
			});
			return result;
		})
		.then((result) => {
			successCallback({ data: result, pagination: { count: result.length } });
		})
		.catch((error) => {
			failureCallback(error);
		});
};

const deleteAnyAutomationService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	if (options.v1) {
		deleteAutomationServiceV1(options, successCallback, failureCallback);
	} else {
		deleteAutomationService(options, successCallback, failureCallback);
	}
};

const renameAnyAutomationService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	if (options.v1) {
		patchAutomationServiceV1(
			{
				id: options.automationId,
				automationId: options.automationId,
				automation: { name: options.newName },
			},
			successCallback,
			failureCallback
		);
	} else {
		renameAutomationService(
			{
				automationId: options.automationId,
				newName: options.newName,
			},
			successCallback,
			failureCallback
		);
	}
};

const createCustomEventService = (
	options,
	successCallback = () => { },
	failureCallback = () => { }
) => {
	callAPI(
		{
			url: GATEWAY_PROXY + "/customevents/register",
			method: METHODS.post,
			body: options,

		},
		successCallback,
		failureCallback
	);
};
const triggerAutomationManuallyService = (
	options,
	successCallback,
	failureCallback
) => {
	const { automationId, ...restOptions } = options;

	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/trigger`,
			method: METHODS.post,
			body: restOptions,

		},
		successCallback,
		failureCallback
	);
};
const triggerBatchAutomationService = (
	options,
	successCallback,
	failureCallback
) => {
	const { automationId, ...restOptions } = options;

	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/backpopulate`,
			method: METHODS.post,
			body: restOptions,

		},
		successCallback,
		failureCallback
	);
};
/**
 *
 * @param {*} options
 * @param {*} successCallback
 * @param {*} failureCallback
 */
function listAutomationVisitorsService(
	options,
	successCallback,
	failureCallback
) {
	const { automationId, ...restOptions } = options;
	//const queryParams = new URLSearchParams(options);
	callAPI(
		{
			url: GATEWAY_PROXY + `/automations/${automationId}/visitors`,
			method: METHODS.get,
			query: { options },
		},
		successCallback,
		failureCallback
	);
}
export {
	deleteAnyAutomationService,
	renameAnyAutomationService,
	listAutomationsService,
	deleteAutomationService,
	activateAutomationService,
	createAutomationService,
	getAutomationService,
	sendTestActionService,
	publishAutomationService,
	createEmailContentService,
	updateAutomationService,
	renameAutomationService,
	getEmailContentService,
	getEmailContentServiceJson,
	getStepStatsService,
	deactivateAutomationService,
	copyEmailContentService,
	unpauseAutomationService,
	pauseAutomationService,
	listAllAutomationsService,
	terminateAutomationService,
	listAutomationExecutionsService,
	terminateExecutionService,
	getEmailContentServiceHTML,
	createCustomEventService,
	triggerAutomationManuallyService,
	listAutomationVisitorsService,
	triggerBatchAutomationService,
};
